export default __webpack_public_path__ + "static/media/ChosainProvince.c03082ee.jpg";